import Input from './input';

export { default as InputError } from './error';

export default Input;
